'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');
var range = require('@mx/util/range');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', [_c('div', {
      ref: "banner",
      staticClass: "banner",
      class: {
        'banner-full': _vm.isFull
      }
    }, [_vm.count > 1 ? _c('ul', {
      ref: "track",
      staticClass: "banner-track",
      style: _vm.style,
      on: {
        "touchstart": _vm.onTouchStart,
        "touchmove": _vm.onTouchMove,
        "touchend": _vm.onTouchEnd,
        "touchcancel": _vm.onTouchEnd
      }
    }, [_vm._t("default")], 2) : _c('ul', {
      staticClass: "banner-track"
    }, [_vm._t("default")], 2), _vm._v(" "), _vm.count > 1 && _vm.paginationType === 'inner' ? _c('div', {
      staticClass: "banner-pagination",
      class: {
        'banner-pagination-inner': _vm.paginationType === 'inner',
        'banner-pagination-deep-style': _vm.paginationTheme === 'dark'
      }
    }, _vm._l(_vm.count, function (index) {
      return _c('i', {
        key: index,
        class: {
          active: index - 1 === _vm.activePoint
        }
      });
    }), 0) : _vm._e()]), _vm._v(" "), _vm.count > 1 && _vm.paginationType === 'outer' ? _c('div', {
      staticClass: "banner-pagination banner-pagination-deep-style",
      class: {
        'banner-pagination-outer': _vm.paginationType === 'outer',
        'banner-pagination-deep-style': _vm.paginationTheme === 'dark'
      }
    }, _vm._l(_vm.count, function (index) {
      return _c('i', {
        key: index,
        class: {
          active: index - 1 === _vm.activePoint
        }
      });
    }), 0) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'banner',
  props: {
    count: {
      type: Number,
      required: true
    },
    loop: Boolean,
    value: Number,
    autoplay: Number,
    movePercent: Number,
    paginationType: {
      type: String,
      default: 'inner'
    },
    isFull: {
      type: Boolean,
      default: false
    },
    paginationTheme: {
      type: String,
      default: 'light'
    }
  },
  data: function data() {
    return {
      timer: 0,
      width: utils.deviceInfo.winWidth,
      offset: 0,
      startX: 0,
      startY: 0,
      active: -2,
      deltaX: 0,
      duration: 0,
      direction: ''
    };
  },
  computed: {
    style: function style() {
      return {
        transitionDuration: "".concat(this.duration, "ms"),
        transform: "translate3d(".concat(this.offset, "px, 0, 0)")
      };
    },
    activePoint: function activePoint() {
      return (this.active + this.count) % this.count;
    }
  },
  mounted: function mounted() {
    this.watchCount();
    this.watchActive();
    this.watchAutoplay();
  },
  methods: {
    watchActive: function watchActive() {
      if ((this.value + this.count) % this.count !== this.activePoint || this.active === -2) {
        this.active = this.value;
        this.move();
      }
    },
    watchCount: function watchCount() {
      var _this = this;

      if (this.count > 1) {
        this.$nextTick(function () {
          var track = _this.$refs.track;
          var slides = track.children;
          track.insertAdjacentHTML('afterbegin', slides[slides.length - 1].outerHTML);
          track.appendChild(slides[1].cloneNode(true));
        });
      }
    },
    watchAutoplay: function watchAutoplay() {
      if (this.autoplay) {
        this.autoPlay();
      } else {
        clearTimeout(this.timer);
      }
    },
    onTouchStart: function onTouchStart(event) {
      clearTimeout(this.timer);
      this.deltaX = 0;
      this.duration = 0;
      this.direction = '';
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;

      if (this.active === -1) {
        this.move(this.count);
      } else if (this.active === this.count) {
        this.move(-this.count);
      }
    },
    onTouchMove: function onTouchMove(event) {
      this.direction = this.direction || this.getDirection(event.touches[0]);

      if (this.direction === 'horizontal') {
        event.preventDefault();
        this.deltaX = event.touches[0].clientX - this.startX;

        if (this.loop || (this.active !== 0 || this.deltaX <= 0) && (this.active !== this.count - 1 || this.deltaX >= 0)) {
          this.move(0, range.range(this.deltaX, [-this.width, this.width]));
        }
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (this.deltaX) {
        this.move(Math.abs(this.deltaX) > 50 ? this.deltaX > 0 ? -1 : 1 : 0);
        this.duration = 300;
      }

      this.autoPlay();
    },
    move: function move() {
      var _move = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var active = this.active;

      if (_move) {
        active += _move;

        if (!this.loop) {
          active = range.range(active, [0, this.count - 1]);
        }

        this.active = active;
        this.$emit('input', this.activePoint);
      }

      this.offset = offset - (active + 1) * this.width;
      var percent = Number((Math.abs(offset) / this.width).toFixed(3));
      this.$emit('update:movePercent', percent);
    },
    autoPlay: function autoPlay() {
      var _this2 = this;

      var autoplay = this.autoplay;

      if (autoplay && this.count > 1) {
        clearTimeout(this.timer);
        this.timer = window.setTimeout(function () {
          _this2.duration = 0;

          if (_this2.active === _this2.count) {
            _this2.move(-_this2.count);
          }

          setTimeout(function () {
            _this2.duration = 450;

            _this2.move(1);

            _this2.autoPlay();
          }, 30);
        }, autoplay);
      }
    },
    getDirection: function getDirection(touch) {
      var distanceX = Math.abs(touch.clientX - this.startX);
      var distanceY = Math.abs(touch.clientY - this.startY);
      return distanceX > distanceY ? 'horizontal' : distanceX < distanceY ? 'vertical' : '';
    }
  },
  watch: {
    value: function value() {
      this.watchActive();
    },
    count: function count() {
      this.watchCount();
    },
    autoplay: function autoplay() {
      this.watchAutoplay();
    }
  }
});

exports.default = index;
